import React from 'react';
import {iconName, qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {createIntegratedRootAliasInstance} from '@packages/utilities/integrated-types';

const FormTextarea = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    const inputClasses = classes.push('w-input');
    return <textarea {...generateAttributes(attributes, inputClasses)} />;
  }
);

const config = Atom.create({
  displayName: 'Textarea',
  constraints: {
    ancestors: [
      {
        is: 'FormForm',
        rule: 'ExactlyOne',
      },
    ],
  },
  dataType: createIntegratedRootAliasInstance(
    qualify(Plugins.name('Form'), typeName('FormTextarea'))
  ),
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Textarea')),
  },
  showEmpty: false,
  render: FormTextarea,
});

export default config;
